import React from 'react'
import { Component } from 'react'

class Carousel extends Component {
    constructor(props) {
        super(props)
        this.element = React.createRef()
    }

    static defaultProps = {
        render: (item, i) => (<img src={item.url} alt={'Item ' + i} draggable="false" />)
    }

    state = { 
        width: 0,
        activeItem: 0,
        itemWidths: {},
        maxOffset: 999,
        dragOffset: 0,
        dragInitialPos: undefined,
        hovered: false,
    }

    getElementWidth = (element) => {
        const width = element.getBoundingClientRect().width
        const style = element.currentStyle || (window && window.getComputedStyle(element))
        const marginLeft = style['margin-left']
        const marginRight = style['margin-right']
        // const borderLeft = style['border-left-width']
        // const borderRight = style['border-right-width']
        return width + parseInt(marginLeft) + parseInt(marginRight) // + parseInt(borderLeft) + parseInt(borderRight)
    }

    getActiveGroup = () => this.state.groups.findIndex(x => x.indexOf(this.state.activeItem) > -1)  
  
    getOffset = (scroll) => {
        let offset = Object.values(this.state.itemWidths)
            .filter((_, i) => i < this.state.activeItem)
            .reduce((acc, x) => acc + x, 0)

        offset += !scroll ? 
            this.state.dragOffset :
            this.state.dragOffset * 3
        
        if (offset < 0)
            offset = 0    
        
        return offset < this.state.maxOffset ?
            offset : this.state.maxOffset
    }

    setActiveItem = (index) => this.setState({ activeItem: index })

    setDragInitialPos = (e) => this.setState({ dragInitialPos: e.screenX })
  
    setDragOffset = (e) => {
        const { dragInitialPos } = this.state
        if (dragInitialPos)
            this.setState({ dragOffset: dragInitialPos - e.screenX })
    }
  
    onDragEnd = (scroll) => {
        if (this.state.dragInitialPos) {
            const offset = this.getOffset(scroll)
            const items = Object.values(this.state.itemWidths)
    
            let i = 0
            let width = 0
            while (i < items.length && width < offset) {
                width += items[i]
                i++
            }
            
            this.setState({ 
                activeItem: i,
                dragInitialPos: undefined,
                dragOffset: 0
            }) 
        }    
    }

    handleResize = (width) => {
        const itemWidths = Object.values(this.state.itemWidths)
        const groups = []    
        let group = []
        let total = 0

        for (let i = 0; i < itemWidths.length; i++) {
            const itemWidth = itemWidths[i]
            total += itemWidth
            if (total < width + 16) { // +16 for margin - right
                group.push(i)
            }
            else {
                groups.push(group)
                group = [i]
                total = itemWidth
            }
        }

        groups.push(group)

        this.setState({ width, groups, maxOffset: itemWidths.reduce((acc, x) => acc + x, 0) - width })
    }

    incrementActiveItem = () => {
        if (!this.state.hovered && this.state.activeItem < this.props.items.length - 1)
            this.setActiveItem(this.state.activeItem + 1)
    }

    render() {
        const { groups, renderedItems } = this.state

        const style = { left: `-${this.getOffset()}px` }
        if (this.state.dragInitialPos)
            style.transition = 'default'

        return (
            <div className="carousel"
                 onMouseOver={() => this.setState({ hovered: true })}
                 onMouseLeave={() => { this.setState({ hovered: false }); this.onDragEnd(true)}}
                 onMouseDown={this.setDragInitialPos}
                 onMouseUp={() => this.onDragEnd(false)}>
                <div className="carousel__container"
                     ref={this.element}
                     style={style}
                     onMouseMove={this.setDragOffset}>
                    {renderedItems}
                </div>
                <div className="carousel__dots">
                    { groups && groups.length > 1 && groups.map((group, i) => (
                        <div key={'carousel__dot--' + i}
                            className={'carousel__dot' + (i === this.getActiveGroup() ? ' carousel__dot--active' : '')}
                            onClick={() => this.setActiveItem(group[0])} />
                    ))}
                </div>
            </div>
        )
    }

    componentDidMount() {
        this.setState({ intervalKey: window && window.setInterval(this.incrementActiveItem, 5000) })
        this.reset()
    }

    reset = () => {
        setTimeout(() => {
            const { items, render } = this.props
            const itemWidths = {}
            
            this.element.current &&
            this.element.current.childNodes.forEach(
                (element, i) => itemWidths[i] = this.getElementWidth(element))

            this.setState({
                activeItem: 0, 
                itemWidths,
                renderedItems: items && items.map((item, i) => (
                    <div key={'carousel__item--' + i}
                            className="carousel__item">
                        {render(item, i)}
                    </div>
                ))
            }, () => this.handleResize(this.state.width))
        }, 250)
    }

    componentDidUpdate() {
        const jsonItems = JSON.stringify(this.props.items)
        if (jsonItems != this.state.itemCache) {
            this.setState({ itemCache: jsonItems })
            this.reset()
        }

        // This should be reduntand with the above check noe, but it's legacy so i don't want to remove it - rrogers 2026-03-03
        if (this.props.items.length !== Object.values(this.state.itemWidths).length)
            this.reset()

        if (!this.state.resizeObserver && this.element.current) {
            const resizeObserver = new ResizeObserver(entries => {
                const { width } = entries[0].contentRect
                this.handleResize(width)
            })
    
            resizeObserver.observe(this.element.current)

            this.setState({ resizeObserver })
        }
    }

    componentWillUnmount() {
        window && window.clearInterval(this.state.intervalKey)

        if (this.state.resizeObserver)
            this.state.resizeObserver.disconnect()
    }
}

export default Carousel